// MEC help text — central source of truth for the "?" pop-overs surfaced
// throughout the Month-End Close UI by HelpPill.
//
// Keys are referenced by HelpPill's `topic` prop. Each entry has a short
// title (heading inside the popover) and a body (one-paragraph explanation).
//
// Keep copy plain-English, audience = bookkeeper, not engineer.

export const HELP = {
  health_score: {
    title: 'Close Health Score',
    body:
      'A 0–100 score combining Tier 1 match rate, memo discipline, credit-pending balance, and aging. Higher is cleaner. Below 60 means action needed.',
  },
  per_ro_view: {
    title: 'Per-RO view',
    body:
      'Default view groups every QBO bill by its repair order. Click a row to see all parts and matches for that RO. Use Audit Mode for the original tab-based breakdown.',
  },
  audit_mode: {
    title: 'Audit Mode',
    body:
      'Power-user view organized by matcher bucket (Tier 1, Tier 2, Credit Pending, etc.). Use this when you know exactly which bucket you want to audit.',
  },
  matched: {
    title: 'Matched ROs',
    body:
      'Repair orders whose parts costs are accounted for in QBO and now in COGS. No action needed.',
  },
  wip: {
    title: 'Work-in-Progress ROs',
    body:
      'Open repair orders with parts received but not yet billed to a customer. Sits as a balance-sheet asset until the RO closes.',
  },
  tier1: {
    title: 'Tier 1 Matches',
    body:
      'QBO bills with a `PO:` memo that resolved cleanly to a Tekmetric receipt. Clean Matches are auto-bucketed; PO Total Mismatches need investigation.',
  },
  tier2: {
    title: 'Tier 2 Pending',
    body:
      'QBO bills without a `PO:` memo that the matcher guessed via vendor + amount + date. You must Confirm or Reject each one.',
  },
  creditPending: {
    title: 'Credit Pending',
    body:
      'Money paid in QBO that we expect a refund or credit for. Already booked to A_pending_return on the journal entry. Chase the vendor for the credit memo.',
  },
  tier3: {
    title: 'Tier 3 Leakage',
    body:
      'QBO bills the matcher could not link to any Tekmetric receipt. Either the bookkeeper forgot the `PO:` memo or the part was never entered in Tekmetric. Process gap.',
  },
  ambiguous: {
    title: 'Ambiguous',
    body:
      'PO totals where QBO over-billed compared to Tekmetric received. Drill in to see which specific vendor is over the line.',
  },
  variance_positive: {
    title: 'Positive variance',
    body:
      'QBO paid more than was matched to Tekmetric or WIP. This is leakage signal — investigate the Ambiguous and Tier 3 tabs.',
  },
  variance_negative: {
    title: 'Negative variance',
    body:
      'Recovery — refunds or credits flowed back in this period. Healthy if expected; concerning if unexpected.',
  },
  tier3_no_po: {
    title: 'No PO# in QBO memo',
    body:
      'The bookkeeper entered a bill without writing `PO: <RO#>` in the memo. Biggest variance lever — train the bookkeeper.',
  },
  tier3_po_not_in_tekmetric: {
    title: 'Unknown PO# in QBO',
    body:
      'The bookkeeper wrote a PO# that does not exist in Tekmetric. Either invented PO# or the shop forgot to create the PO in Tek.',
  },
};
